export default {
  system: {
    loading: "Chargement...",
    project_name: "Assistant d’Auto-Confinement"
  },
  home: {
    welcome: "Bienvenue"
  },
  welcome: {
    incorrect_link: "Le lien est incorrect",
    introduction:
      "L’auto-confinement est primordial pour combattre la pandémie du COVID19. C’est une étape nécessaire qui nous concerne tous et qui permet d’aider à limiter la propagation du virus et à protéger ceux qui nous entourent.",
    guidance_use_phone:
      "Ce site utilise les fonctionnalités de votre téléphone pour détecter où vous vous trouver.",
    guidance_grant_permission_1:
      "Donnez les autorisations requises s’il-vous-plaît",
    guidance_grant_permission_2:
      "Afin d’utiliser votre localisation actuelle. Cet outil s’assure que vous respectez les règles d’auto-confinement. Veuillez contacter les autorités locales en cas de question.",
    guidance_enable_location:
      "Si la fonctionnalité de géolocalisation est désactivée, merci de l’activer dans les paramètres de votre téléphone.",
    additional_iphone_link_text: "Informations additionnelles de l’iPhone",
    additional_android_link_text: "Informations additionnelles de l’Android",
    start_button: "Démarrer"
  },
  locate: {
    report_location_button: "Signaler votre localisation",
    geolocation_not_available_tips:
      "Votre téléphone ne prend pas en charge la géolocalisation.",
    geolocation_not_enabled_tips:
      "Veuillez activer la fonctionnalité de géolocalisation et recommencez.",
    reported_location: "Votre localisation signalée",
    latitude: "Latitude",
    longitude: "Longitude",
    thank_introduction:
      "Merci pour votre coopération, merci de veuillez à rester confiné pendant 14 jours pour la sécurité de tous. Cliquez sur le bouton pour envoyer vos résultats.",
    getting_location_data: "En cours de réception des données de localisation"
  },
  thank: {
    thank_you: "Merci",
    thank_cooperation:
      "Merci de votre coopération, n’oubliez pas de vous laver les mains régulièrement."
  },
  android: {
    setting_title: "Paramètre Android",
    introduction:
      "Vous pouvez changer les paramètres de localisation de votre navigateur grâce à ces quelques étapes. Vous n’avez besoin de le faire qu’une fois.",
    setting_step_1: "Allez dans Settings",
    setting_step_2: "Cliquez sur Sécurité & Localisation",
    setting_step_3: "Descendez et cliquez sur Localisation",
    setting_step_4: "Assurez-vous que la fonctionnalité est activée"
  },
  iphone: {
    setting_title: " Paramètres iPhone",
    introduction:
      "Vous pouvez modifier les paramètres de localisation de votre navigateur via ces étapes simples, vous n’avez qu’à le faire une seule fois.",
    setting_step_1: "Aller aux paramètres",
    setting_step_2: "Choisissez l’option confidentialité",
    setting_step_3:
      "Choisissez Services de localisation et assurez-vous que cette fonctionnalité est activée",
    setting_step_4: 'Descendez jusqu’à "Safari Websites", et sélectionnez-le',
    setting_step_5:
      'Assurez-vous que la fonctionnalité "Tout en utilisant l’application" est sélectionnée'
  }
};
